/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Navigate, RouteObject } from 'react-router-dom';

import { getRoute, HOME_ROUTE, mapRouteToRelativePath } from '../../util/routing';
import UserAccountScreen from './pages/UserAccount/UserAccountScreen';
import ProfileScreen from './pages/Profile/ProfileScreen';
import SelectedAccountDetailsScreen from './pages/SelectedAccountDetails/SelectedAccountDetailsScreen';

export const ACCOUNT_ROUTE_NAME = 'account';
export const ACCOUNT_ROUTE = mapRouteToRelativePath(ACCOUNT_ROUTE_NAME);

export const PROFILE_ROUTE_NAME = 'profile';
export const ACCOUNT_PROFILE_ROUTE = getRoute(ACCOUNT_ROUTE_NAME, PROFILE_ROUTE_NAME);

export const ACCOUNT_DETAILS_ROUTE_NAME = 'account-details';
export const ACCOUNT_ACCOUNT_DETAILS_ROUTE = getRoute(
  ACCOUNT_ROUTE_NAME,
  ACCOUNT_DETAILS_ROUTE_NAME,
);

export const accountRoutes = (isCEUser: boolean, isMobile: boolean): RouteObject[] => [
  {
    path: ACCOUNT_ROUTE,
    element: isMobile ? <UserAccountScreen /> : <Navigate to={HOME_ROUTE} />,
  },
  {
    path: ACCOUNT_PROFILE_ROUTE,
    element: isCEUser ? <Navigate to={HOME_ROUTE} /> : <ProfileScreen />,
  },
  {
    path: ACCOUNT_ACCOUNT_DETAILS_ROUTE,
    element: <SelectedAccountDetailsScreen />,
  },
  { path: `${ACCOUNT_ROUTE_NAME}/*`, element: <Navigate to={ACCOUNT_ROUTE} replace /> },
];
